var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Input as ShadcnInput } from './primitives/input';
function CustomInput(_a) {
    var value = _a.value, props = __rest(_a, ["value"]);
    return <ShadcnInput {...props} value={value !== null && value !== void 0 ? value : ''}/>;
}
export { CustomInput as Input };
